/** API route map: URLS.Controller.CandidateStatus */
export const CandidateStatus = {
      Name: 'CandidateStatus/',
      GetCandidateStatus: 'get-candidate-status',
      AddCandidateStatus: 'add-candidate-status',
      UpdateCandidateStatus: 'update-candidate-status',
      DeleteCandidateStatus: 'delete-candidate-status',
      UpdateCandidateStatusList: 'update-candidate-status-list',
      UpdateCandidateStatusListSearch: 'get-candidate-status-search',
      AddCandidateStatusKeyPipeline: 'add-candidate-status-key-pipeline',
      GetCandidateStatusKeyPipeline: 'get-candidate-status-key-pipeline',
};
